export default [{
    "code": "kcy",
    "parentPath": "0,df25b10b5c2b404b8d1619dc44307e34,",
    "remark": null,
    "updateTime": "2019-12-10 15:28:25",
    "sort": 999,
    "createTime_str": "2019-12-10 15:28:25",
    "delFlag": "0",
    "type": "org",
    "parentId": "0",
    "updateTime_date_str": "2019-12-10",
    "createBy": "1",
    "createTime": "2019-12-10 15:28:25",
    "updateBy": "1",
    "children": [{
        "id": "2c8c4fb1af09465888fbf01cf425ade9",
        "createTime": "2019-12-12 13:08:21",
        "updateTime": "2019-12-12 13:08:21",
        "createBy": "1",
        "updateBy": "1",
        "state": "save",
        "sort": 999,
        "delFlag": "0",
        "parentId": "df25b10b5c2b404b8d1619dc44307e34",
        "parentPath": "0,df25b10b5c2b404b8d1619dc44307e34,2c8c4fb1af09465888fbf01cf425ade9,",
        "name": "审核人员",
        "code": "shry",
        "type": "position",
        "remark": null,
        "children": null
    }],
    "name": "开创云",
    "updateTime_str": "2019-12-10 15:28:25",
    "createUser": null,
    "id": "df25b10b5c2b404b8d1619dc44307e34",
    "state": "save",
    "createTime_date_str": "2019-12-10"
}]



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/sys/organization/queryOrgTreeList.js